var _path, _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSm(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.488 34.836C18.592 34.836 21.016 32.364 21.016 29.46C21.016 26.892 19.6 25.524 17.44 24.636L15.112 23.652C13.6 23.052 12.328 22.596 12.328 21.324C12.328 20.148 13.336 19.452 14.896 19.452C16.36 19.452 17.536 19.98 18.664 20.916L20.464 18.684C19.024 17.22 16.96 16.404 14.896 16.404C11.296 16.404 8.752 18.636 8.752 21.54C8.752 24.132 10.552 25.572 12.352 26.316L14.728 27.324C16.312 27.996 17.392 28.404 17.392 29.724C17.392 30.972 16.408 31.764 14.56 31.764C13 31.764 11.32 30.972 10.048 29.796L8.008 32.244C9.736 33.9 12.112 34.836 14.488 34.836ZM24.1606 34.5H27.3526V27.084C27.3526 25.404 27.0646 22.932 26.8966 21.252H26.9926L28.4086 25.428L31.1686 32.892H33.2086L35.9446 25.428L37.3846 21.252H37.4806C37.3126 22.932 37.0486 25.404 37.0486 27.084V34.5H40.2886V16.74H36.3526L33.4006 25.044C33.0166 26.148 32.7046 27.324 32.3206 28.476H32.2006C31.8406 27.324 31.5046 26.148 31.1206 25.044L28.0966 16.74H24.1606V34.5Z",
    fill: "url(#paint0_linear_596_8636)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 2,
    width: 47,
    height: 47,
    rx: 8.5,
    stroke: "url(#paint1_linear_596_8636)",
    strokeWidth: 3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_596_8636",
    x1: 43,
    y1: 34.5,
    x2: 4.98006,
    y2: 27.5499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F89CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D3F9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_596_8636",
    x1: 50,
    y1: 50.5,
    x2: -4.11793,
    y2: 45.5536,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F89CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D3F9C"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSm);
export default __webpack_public_path__ + "static/media/icon-sm.ad84255827e662f9f8874e770fbed276.svg";
export { ForwardRef as ReactComponent };